<template>
  <div>
    <!-- 咨询登记： -->
    <el-dialog :title="$t('message.consultationRegistration')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1380px" center>
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
          <!-- 客户ID  -->
          <el-form-item :label="$t('message.userID')">
            <el-input v-model="ruleForm.user_id" @blur="clientList"></el-input>
          </el-form-item>
          <!-- 客户名称： -->
          <el-form-item :label="$t('message.userName')" prop="realname">
            <el-input v-model="ruleForm.realname"></el-input>
          </el-form-item>
          <!-- 咨询时间： -->
          <el-form-item :label="$t('message.consultationTime')" prop="consult_at">
            <el-date-picker v-model="ruleForm.consult_at" :placeholder="$t('message.consultationTime')" type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <!-- 咨询来源： -->
          <el-form-item :label="$t('message.consultationSource')" prop="source">
            <el-radio-group v-model="ruleForm.source">
              <el-radio :label="item.key" v-for="(item, index) in sourceList" :key="index">{{ item.value }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 问题类别 -->
          <el-form-item :label="$t('message.typeOfProblem')" prop="category">
            <el-select v-model="ruleForm.category" filterable>
              <el-option v-for="item in categoryList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 客户咨询内容 -->
          <el-form-item :label="$t('message.customerConsultationContent')" prop="content">
            <quill-editor id="quill-editor" v-model="ruleForm.content" :options="quillOption">
            </quill-editor>
          </el-form-item>
          <!-- 回复内容 -->
          <el-form-item :label="$t('message.replyContent')">
            <quill-editor id="quill-editor" v-model="ruleForm.reply" :options="quillOption">
            </quill-editor>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer" v-if="isAdd">
        <!-- 临时保存-->
        <el-button type="primary" @click="consultStore(0)">
          {{ $t("message.temporaryStorage") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="consultStore(1)">
          {{ $t("message.complete") }}
        </el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-else>
        <!-- 临时保存-->
        <el-button type="primary" @click="consultUpdate(0)">
          {{ $t("message.temporaryStorage") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="consultUpdate(1)">
          {{ $t("message.complete") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    quillEditor
  },
  props: {
    isAdd: { type: Boolean },
    formData: { type: Object },
  },
  data() {
    return {
      quillOption: quillConfig,
      ruleForm: {
      },
      dialogVisible: false,
      rules: {
        source: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        consult_at: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        category: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        realname: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },]
      },
      sourceList: [],//可选来源
      categoryList: [],//可选分类
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.ruleForm = this.formData
      }
    }
  },
  created() {
    this.$api.JapaneseOffice.source().then(res => {
      this.sourceList = res.data
    })
    this.$api.JapaneseOffice.category().then(res => {
      this.categoryList = res.data
    })
  },
  methods: {
    // 新增
    consultStore(status) {
      this.ruleForm.status = status
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.JapaneseOffice.consultStore(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            if (this.$route.name == 'consultationRecords') {
              this.$parent.consultList()
            }
          });
        }
      })
    },
    // 修改
    consultUpdate(status) {
      this.ruleForm.status = status
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.JapaneseOffice.consultUpdate(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.consultList()
          });
        }
      })
    },
    // 客户名
    clientList() {
      if (this.ruleForm.user_id) {
        this.$api.JapaneseOffice.clientInfo({ user_id: this.ruleForm.user_id }).then(res => {
          this.ruleForm.realname = res.data.realname
          this.$forceUpdate()
        })
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
}

/deep/.el-input__inner {
  width: 300px;
}

/deep/.ql-editor {
  min-height: 300px !important;
}
</style>